import { combineReducers } from 'redux'
import user from './User'
import users from './Users'
import wazzup from './Wazzup'
import filtered_wazzup from './FilteredWazzup'
import composer from './Composer'
import sidebar from './Sidebar'
import chat from './Chat'
import guilds from './Guilds'


const rootReducer = combineReducers({
    user,
    users,
    wazzup,
    filtered_wazzup,
    composer,
    sidebar,
    chat,
    guilds,
})

export default rootReducer
